// import { useState } from "react";
// import "../styles/UploadScan.css";
// import ResultsGraph from "./ResultsGraph";

// const BACKEND_URL = "http://127.0.0.1:8000";

// export default function UploadScan({ onNewReport }) {
//   const [file, setFile] = useState(null);
//   const [method, setMethod] = useState("rf"); // rf, xgb, both
//   const [loading, setLoading] = useState(false);
//   const [result, setResult] = useState(null);

//   const handleFileChange = (e) => setFile(e.target.files[0]);

//   const handleScan = async () => {
//     if (!file) {
//       alert("Please select a file to scan");
//       return;
//     }

//     setLoading(true);
//     setResult(null);

//     const mode = method === "both" ? "compare" : "single";
//     const model_name = method === "both" ? "rf" : method;

//     try {
//       const formData = new FormData();
//       formData.append("file", file);
//       formData.append("model_name", model_name);
//       formData.append("mode", mode);

//       const response = await fetch(`${BACKEND_URL}/api/scan`, {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         const text = await response.text();
//         console.error("Backend returned:", text);
//         throw new Error(`Scan failed: ${response.statusText}`);
//       }

//       const data = await response.json();
//       setResult(data);

//       // Notify parent (MainPage) about new report
//       if (onNewReport) onNewReport(data);
//     } catch (error) {
//       console.error("Scan error:", error);
//       alert("Error scanning file. Check console for details.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section id="upload" className="upload-section">
//       <h2 className="section-title">Upload & Scan Files</h2>

//       <div className="scan-container">
//         <div className="upload-block">
//           <h3>Upload File</h3>
//           <input type="file" onChange={handleFileChange} />
//         </div>

//         <div className="method-block">
//           <h3>Choose Method</h3>
//           <select value={method} onChange={(e) => setMethod(e.target.value)}>
//             <option value="rf">Random Forest</option>
//             <option value="xgb">XGBoost</option>
//             <option value="both">Both Models</option>
//           </select>
//         </div>

//         <div className="result-block">
//           <h3>Results</h3>
//           <ResultsGraph result={result} loading={loading} />
//         </div>
//       </div>

//       <button onClick={handleScan} className="scan-btn" disabled={loading}>
//         {loading ? "Scanning..." : "Scan File"}
//       </button>
//     </section>
//   );
// }

// import { useState } from "react";
// import "../styles/UploadScan.css";
// import ResultsGraph from "./ResultsGraph";

// //  Render backend URL
// const BACKEND_URL = "https://backend-ml-malware-detection-and-analysis.onrender.com";

// export default function UploadScan({ onNewReport }) {
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [result, setResult] = useState(null);

//   const handleFileChange = (e) => setFile(e.target.files[0]);

//   const handleScan = async () => {
//     if (!file) {
//       alert("Please select a file to scan");
//       return;
//     }

//     setLoading(true);
//     setResult(null);

//     try {
//       const formData = new FormData();
//       formData.append("file", file);

//       // Production model ONLY(xgb)
//       formData.append("model_name", "xgb");

//       const response = await fetch(`${BACKEND_URL}/api/scan`, {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         const text = await response.text();
//         console.error("Backend returned:", text);
//         throw new Error(`Scan failed: ${response.status}`);
//       }

//       const data = await response.json();
//       setResult(data);

//       // Notify parent component
//       if (onNewReport) onNewReport(data);

//     } catch (error) {
//       console.error("Scan error:", error);
//       alert("Error scanning file. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section id="upload" className="upload-section">
//       <h2 className="section-title">Upload & Scan Files</h2>

//       <div className="scan-container">
//         <div className="upload-block">
//           <h3>Upload File</h3>
//           <input type="file" onChange={handleFileChange} />
//         </div>

//         {/*  Production info message */}
//         <div className="method-block">
//           <h3>Detection Model</h3>
//           <p style={{ color: "#888" }}>
//             XGBoost (Production Model)
//           </p>
//         </div>

//         <div className="result-block">
//           <h3>Results</h3>
//           <ResultsGraph result={result} loading={loading} />
//         </div>
//       </div>

//       <button onClick={handleScan} className="scan-btn" disabled={loading}>
//         {loading ? "Scanning..." : "Scan File"}
//       </button>
//     </section>
//   );
// }

import { useState } from "react";
import "../styles/UploadScan.css";
import ResultsGraph from "./ResultsGraph";

// Render backend URL
const BACKEND_URL =
  "https://backend-ml-malware-detection-and-analysis.onrender.com";

export default function UploadScan({ onNewReport }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  // Allowed PE file extensions
  const allowedExtensions = [".exe", ".dll", ".sys"];

  // Handle file selection + validation
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    const isValid = allowedExtensions.some((ext) =>
      selectedFile.name.toLowerCase().endsWith(ext)
    );

    if (!isValid) {
      alert("Only PE files (.exe, .dll, .sys) are allowed.");
      e.target.value = null;
      setFile(null);
      return;
    }

    setFile(selectedFile);
  };

  // Handle scan request
  const handleScan = async () => {
    if (!file) {
      alert("Please select a valid PE file to scan");
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const formData = new FormData();
      formData.append("file", file);

      // Production model ONLY (xgb)
      formData.append("model_name", "xgb");

      const response = await fetch(`${BACKEND_URL}/api/scan`, {
        method: "POST",
        body: formData,
      });

      // Better backend error handling
      if (!response.ok) {
        const text = await response.text();
        console.error("Backend returned:", text);
        throw new Error(text);
      }

      const data = await response.json();

      setResult(data);

      // Notify parent component
      if (onNewReport) {
        onNewReport(data);
      }

    } catch (error) {
      console.error("Scan error:", error);

      alert(
        error.message ||
        "Error scanning file. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="upload" className="upload-section">
      <h2 className="section-title">Upload & Scan Files</h2>

      <div className="scan-container">

        {/* Upload Section */}
        <div className="upload-block">
          <h3>Upload File</h3>

          <input
            type="file"
            accept=".exe,.dll,.sys"
            onChange={handleFileChange}
          />

          {file && (
            <p className="selected-file">
              Selected: {file.name}
            </p>
          )}
        </div>

        {/* Production Model Info */}
        <div className="method-block">
          <h3>Detection Model</h3>

          <p style={{ color: "#888" }}>
            XGBoost (Production Model)
          </p>
        </div>

        {/* Results */}
        <div className="result-block">
          <h3>Results</h3>

          <ResultsGraph
            result={result}
            loading={loading}
          />
        </div>
      </div>

      {/* Scan Button */}
      <button
        onClick={handleScan}
        className="scan-btn"
        disabled={loading}
      >
        {loading ? "Scanning..." : "Scan File"}
      </button>
    </section>
  );
}
